export const CLIENTS_SMSTEXT_REQUEST = 'CLIENTS_SMSTEXT_REQUEST';
export const CLIENTS_SMSTEXT_SUCCESS = 'CLIENTS_SMSTEXT_SUCCESS';
export const CLIENTS_SMSTEXT_FAILURE = 'CLIENTS_SMSTEXT_FAILURE';
